import styled from 'styled-components/macro';

export const Divider = styled.hr<{ color?: string }>`
  border: 1px solid ${({ color }) => color || 'rgba(200, 204, 214, 0.3)'};
  margin: 0;
`;
